import {css, StyleSheet} from 'aphrodite';
import React, {useMemo} from 'react';

import {FONT_PROXIMA_16} from 'styles/FontConstants';
import {GRAY_DARK, GRAY_LIGHT} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import DataViewContext, {useDataViewContext} from './DataViewContext';
import DataViewPane from './DataViewPane';

/**
 * Render view for steps that are waiting for user configuration.
 *
 * @package
 */
export default function WaitingView(): JSX.Element {
  const dataViewContextValue = useDataViewContext();
  const newDataViewContextValue = useMemo(
    () => ({
      ...dataViewContextValue,
      dataTestAttrs: {component: 'WaitingView', element: 'root'},
    }),
    [dataViewContextValue]
  );

  return (
    <DataViewContext.Provider value={newDataViewContextValue}>
      <DataViewPane>
        <div className={css(styles.waitingViewWrapper)}>
          <BenchlingIcon icon="circle-outline" className={css(styles.icon)} />
          <p className={css(styles.titleText)}>Waiting to be configured</p>
        </div>
      </DataViewPane>
    </DataViewContext.Provider>
  );
}

const styles = StyleSheet.create({
  icon: {
    color: GRAY_LIGHT,
    height: '60px',
    width: '60px',
    marginBottom: 20,
  },
  waitingViewWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  titleText: {
    ...FONT_PROXIMA_16,
    color: GRAY_DARK,
  },
});
